(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    const root = document.querySelector('[data-request-quote-root]');
    if (!root) return;

    const form = root.querySelector('[data-request-quote-form]');
    if (!form) return;

    const formWrapper = root.querySelector('[data-request-quote-form-wrapper]');
    const successContainer = root.querySelector('[data-request-quote-success]');
    const errorContainer = root.querySelector('[data-request-quote-error]');
    const submitButton = form.querySelector('[data-request-quote-submit]');

    const defaultCustomerValues = {
      name: (root.dataset.customerName || '').trim(),
      phone: (root.dataset.customerPhone || '').trim(),
      email: (root.dataset.customerEmail || '').trim(),
      address: (root.dataset.customerAddress || '').trim()
    };

    if (form) {
      const applyDefaultValue = (fieldName, value) => {
        if (!value) return;
        const field = form.elements[fieldName];
        if (field && !field.value) {
          field.value = value;
        }
      };

      applyDefaultValue('name', defaultCustomerValues.name);
      applyDefaultValue('phone', defaultCustomerValues.phone);
      applyDefaultValue('email', defaultCustomerValues.email);
      applyDefaultValue('address', defaultCustomerValues.address);
    }

    const endpoint = (root.dataset.endpoint || '').trim();
    const successHeading = root.dataset.successHeading || '';
    const successBody = root.dataset.successBody || '';
    const errorMessage = root.dataset.errorMessage || '';
    const missingEndpointMessage = root.dataset.missingEndpoint || errorMessage;
    const continueLabel = root.dataset.continueLabel || '';
    const continueUrl = root.dataset.continueUrl || '/';
    const submittingLabel = root.dataset.submittingLabel || '';
    const clearCart = root.dataset.clearCart === 'true';

    let isSubmitting = false;
    const originalButtonText = submitButton ? submitButton.textContent : '';

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (isSubmitting) return;

      hideError();

      if (!endpoint) {
        showError(missingEndpointMessage);
        return;
      }

      isSubmitting = true;
      setButtonState(true);

      try {
        const payload = await buildPayload(form);
        await sendPayload(endpoint, payload);

        if (clearCart) {
          try {
            await fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' });
          } catch (cartError) {
            console.warn('Failed to clear cart after quote submission', cartError);
          }
        }

        renderSuccess();
      } catch (error) {
        console.error('Request quote submission failed', error);
        showError(error.message === 'quote_request_failed' ? errorMessage : error.message || errorMessage);
      } finally {
        setButtonState(false);
        isSubmitting = false;
      }
    });

    function setButtonState(disabled) {
      if (!submitButton) return;
      submitButton.disabled = disabled;
      submitButton.setAttribute('aria-busy', String(disabled));
      if (disabled && submittingLabel) {
        submitButton.textContent = submittingLabel;
      } else {
        submitButton.textContent = originalButtonText;
      }
    }

    async function buildPayload(formElement) {
      const formData = new FormData(formElement);
      const customer = {
        name: (formData.get('name') || '').toString().trim(),
        phone: (formData.get('phone') || '').toString().trim(),
        email: (formData.get('email') || '').toString().trim(),
        address: (formData.get('address') || '').toString().trim(),
        comment: (formData.get('comment') || '').toString().trim()
      };

      const cart = await fetchCart();
      
      // Verify quantity calculations for items with pack_size
      // This prevents double-multiplication issues before sending to server
      if (cart.items && Array.isArray(cart.items)) {
        cart.items.forEach((item, index) => {
          if (item.properties && Array.isArray(item.properties)) {
            const packSizeProp = item.properties.find(p => p && p.name === 'pack_size');
            const packsProp = item.properties.find(p => p && p.name === 'packs');
            
            if (packSizeProp && packsProp) {
              const packSize = Number(packSizeProp.value) || 0;
              const packs = Number(packsProp.value) || 0;
              const expectedQuantity = packs * packSize;
              const actualQuantity = Number(item.quantity) || 0;
              
              if (packSize > 0 && packs > 0 && expectedQuantity > 0) {
                if (Math.abs(actualQuantity - expectedQuantity) > 0.01) {
                  console.warn(`[request-quote.js] Quantity mismatch for item ${index + 1}: ` +
                    `quantity=${actualQuantity}, packs=${packs}, pack_size=${packSize}, expected=${expectedQuantity}. ` +
                    `Correcting quantity before sending to server.`);
                  cart.items[index].quantity = expectedQuantity;
                }
              }
            }
          }
        });
      }

      return {
        customer,
        cart,
        context: {
          source: 'request-quote-form'
        }
      };
    }

    async function fetchCart() {
      const response = await fetch('/cart.js', {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('quote_request_failed');
      }

      return response.json();
    }

    async function sendPayload(url, payload) {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error('quote_request_failed');
      }

      return response;
    }

    function renderSuccess() {
      if (formWrapper) {
        formWrapper.setAttribute('hidden', 'hidden');
      }

      if (!successContainer) return;

      successContainer.innerHTML = '';

      if (successHeading) {
        const heading = document.createElement('h2');
        heading.textContent = successHeading;
        successContainer.appendChild(heading);
      }

      if (successBody) {
        const body = document.createElement('p');
        body.textContent = successBody;
        successContainer.appendChild(body);
      }

      if (continueLabel) {
        const button = document.createElement('a');
        button.className = 'button';
        button.href = continueUrl;
        button.textContent = continueLabel;
        successContainer.appendChild(button);
      }

      successContainer.setAttribute('aria-hidden', 'false');
    }

    function showError(message) {
      if (!errorContainer) return;
      errorContainer.textContent = message;
      errorContainer.setAttribute('aria-hidden', 'false');
    }

    function hideError() {
      if (!errorContainer) return;
      errorContainer.textContent = '';
      errorContainer.setAttribute('aria-hidden', 'true');
    }
  });
})();
